/** @format */

export const timeTypeList = [
	{
		label: '年-月-日 时:分:秒',
		format: 'YYYY-MM-DD HH:mm:ss',
		type: 'datetime',
	},
	{
		label: '年-月-日 时:分',
		format: 'YYYY-MM-DD HH:mm',
		type: 'datetime',
	},
	{
		label: '年-月-日 时',
		format: 'YYYY-MM-DD HH',
		type: 'datetime',
	},
	{
		label: '年-月-日',
		format: 'YYYY-MM-DD',
		type: 'date',
	},
	{
		label: '年-月',
		format: 'YYYY-MM',
		type: 'month',
	},
	{
		label: '年',
		format: 'YYYY',
		type: 'year',
	},
	{
		label: '时:分:秒',
		format: 'HH:mm:ss',
		type: 'time',
	},
	{
		label: '时:分',
		format: 'HH:mm',
		type: 'time',
	},
];

export const userLink = [
	{
		label: '姓名',
		value: 'userName',
	},
	{
		label: '用户id',
		value: 'userId',
	},
	{
		label: '账号',
		value: 'userAccount',
	},
	{
		label: '部门',
		value: 'dept.deptName',
	},
	{
		label: '邮箱',
		value: 'email',
	},
	{
		label: '电话',
		value: 'phonenumber',
	},
];

export const deptLink = [
	{
		label: '部门名称',
		value: 'deptName',
	},
	{
		label: '部门id',
		value: 'deptId',
	},
	{
		label: '主管',
		value: 'leader',
	},
];

export const getLinkList = (type) => {
	switch (type) {
		case 'user':
			return userLink;
		case 'department':
			return deptLink;
		default:
			return userLink;
	}
};
